import React, {Fragment} from "react";
import BasicSelect from "../../../common/BasicSelect";

export default function StatusSelect({ id, name, label, placeholder, defaultValue, input, meta }) {
    const options = [
        { 'id': true, 'name': 'Enabled' },
        { 'id': false, 'name': 'Disabled' },
    ]

    return(
        <Fragment>
            <BasicSelect
                id={id}
                name={name}
                label={label}
                placeholder={placeholder}
                defaultValue={defaultValue}
                options={options}
                input={input}
                meta={meta} />
        </Fragment>
    )
}